export type Member = {
   name: string;
   title: string;
   imagePath: string;
   url: string | null;
}


export const members: Member[] = [
   {
      imagePath: require("../assets/Images/Headshots/FA26/Daniel_Smothers.jpg"),
      name: "Daniel Smothers",
      title: "Co-President",
      url: null,
   },
   {
      imagePath: require("../assets/Images/Headshots/FA26/Vikram_Nandi.jpg"),
      name: "Vikram Nandi",
      title: "Co-President",
      url: null,
   },
   {
      imagePath: require("../assets/Images/Headshots/FA26/Benjamin_Smothers.jpg"),
      name: "Benjamin Smothers",
      title: "Education Director",
      url: "https://www.linkedin.com/in/benjamin-smothers/",
   },
   {
      imagePath: require("../assets/Images/Headshots/FA26/Carlos_Herrera.jpg"),
      name: "Carlos Herrera",
      title: "Culture Director",
      url: null,
   },
   {
      imagePath: require("../assets/Images/Headshots/FA26/blank.jpeg"),
      name: "Amanda Hernandez",
      title: "Marketing",
      url: null,
   },
   {
      imagePath: require("../assets/Images/Headshots/FA26/Leslie_Castellon_Segovia.jpeg"),
      name: "Leslie Castellon-Segovia",
      title: "Outreach",
      url: "https://www.linkedin.com/in/leslie-castellon-segovia-04b04b315/",
   },
   {
      imagePath: require("../assets/Images/Headshots/FA26/Caden_Pun.jpg"),
      name: "Caden Pun",
      title: "Project Lead",
      url: null,
   },
   {
      imagePath: require("../assets/Images/Headshots/FA26/Yukai_Qiu.png"),
      name: "Yukai Qiu",   
      title: "Project Lead",
      url: null,
   },
   {
      imagePath: require("../assets/Images/Headshots/FA26/Alice_Wu.jpg"),
      name: "Alice Wu",
      title: "Project Lead",
      url: null,
   },
   {
      imagePath: require("../assets/Images/Headshots/FA26/Enoch_Chen.jpg"),
      name: "Enoch Chen",
      title: "Project Lead",
      url: null,
   },
   {
      imagePath: require("../assets/Images/Headshots/FA26/Emiliano_Cereceres.jpg"),
      name: "Emiliano Cereceres",
      title: "Project Lead",
      url: "https://www.linkedin.com/in/emiliano-cereceres/",
   },
   {
      imagePath: require("../assets/Images/Headshots/FA26/Tarun_Natham.png"),
      name: "Tarun Natham",
      title: "Developer",
      url: "https://www.linkedin.com/in/tarun-natham/",
   },
   {
      imagePath: require("../assets/Images/Headshots/FA26/Raj_Longia.jpeg"),
      name: "Raj Longia",
      title: "Developer",
      url: "https://www.linkedin.com/in/rajbir-longia",
   },
   {
      imagePath: require("../assets/Images/Headshots/FA26/Diego_Zamora_Martinez.jpg"),
      name: "Diego Zamora Martinez",
      title: "Developer",
      url: "https://www.linkedin.com/in/diego-zamora-martinez/",
   },
   {
      imagePath: require("../assets/Images/Headshots/FA26/Bruce_Deng.jpg"),
      name: "Bruce Deng",
      title: "Developer",
      url: null,
   },
   {
      imagePath: require("../assets/Images/Headshots/FA26/Levi_Serrano.jpg"),
      name: "Levi Serrano",
      title: "Developer",
      url: "https://www.linkedin.com/in/leviserrano2/",
   },
   {
      imagePath: require("../assets/Images/Headshots/FA26/Phil_Qiu.jpg"),
      name: "Phil Qiu",
      title: "Developer",
      url: null,
   },
   {
      imagePath: require("../assets/Images/Headshots/FA26/Santhusha_Mudannayaka.png"),
      name: "Sana Mudannayaka",
      title: "Developer",
      url: "https://www.linkedin.com/in/santhusha-mudannayaka/",
   },
   {
      imagePath: require("../assets/Images/Headshots/FA26/Christopher_Wang.jpg"),
      name: "Chris Wang",
      title: "Developer",
      url: "https://www.linkedin.com/in/christopher-wang-8927a9328/",
   },
   {
      imagePath: require("../assets/Images/Headshots/FA26/Karthik_Subramanian.jpg"),
      name: "Karthik Subramanian",
      title: "Developer",
      url: "https://linkedin.com/in/karthik-subramanian-07",
   },
   {
      imagePath: require("../assets/Images/Headshots/FA26/Aadit_Abhilash.jpeg"),
      name: "Aadit Abhilash",
      title: "Developer",
      url: "https://www.linkedin.com/in/aadit-abhilash/",
   },
   {
      imagePath: require("../assets/Images/Headshots/FA26/Prabhav_Goel.jpg"),
      name: "Prabhav Goel",
      title: "Developer",
      url: "https://www.linkedin.com/in/prabhav-goel8/",
   },
   {
      imagePath: require("../assets/Images/Headshots/FA26/Siriwath_Edwards.jpg"),
      name: "Siriwath Edwards",
      title: "Developer",
      url: "https://www.linkedin.com/in/siriwath/",
   },
   {
      imagePath: require("../assets/Images/Headshots/FA26/Gautam_Kathiravan.png"),
      name: "Gautam Kathiravan",
      title: "Developer",
      url: null,
   },
   {
      imagePath: require("../assets/Images/Headshots/FA26/Chris_Shen.jpg"),
      name: "Chris Shen",
      title: "Developer",
      url: "https://www.linkedin.com/in/chris-shen-a5a8bb327",
   },
   {
      imagePath: require("../assets/Images/Headshots/FA26/Eric_Cao.jpeg"),
      name: "Eric Cao",
      title: "General Member",
      url: null,
   },
   {
      imagePath: require("../assets/Images/Headshots/FA26/Arthur_Sanchez.jpg"),
      name: "Arthur Sanchez",
      title: "General Member",
      url: "https://www.linkedin.com/in/arthur-cal/",
   }
];


